import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * SpinnerService — gerencia estado de loading global.
 * Controla contagem de requisições concorrentes para
 * evitar hide prematuro quando múltiplas chamadas estão ativas.
 */
@Injectable({ providedIn: 'root' })
export class SpinnerService {
  private activeRequests = 0;
  private _loading$ = new BehaviorSubject<boolean>(false);

  /** Observable reativo para uso em templates com async pipe */
  readonly loading$ = this._loading$.asObservable();

  show(): void {
    this.activeRequests++;
    if (this.activeRequests === 1) {
      this._loading$.next(true);
    }
  }

  hide(): void {
    this.activeRequests = Math.max(0, this.activeRequests - 1);
    if (this.activeRequests === 0) {
      this._loading$.next(false);
    }
  }

  /** Força o hide independente do contador */
  forceHide(): void {
    this.activeRequests = 0;
    this._loading$.next(false);
  }

  get isLoading(): boolean {
    return this._loading$.value;
  }
}
